{
  "pageTitle": "العمليات",
  "branch": "الفرع",
  "businessDate": "تاريخ العمل",
  "archiveBanner": "أرشيف",
  "frozenNotice": "النظام مجمد مؤقتا لعملية إدارة السنوات",
  "revolvingBalanceRequired": "لا عمليات على {{product}} قبل إدخال الرصيد المدور لتاريخ العمل الحالي",
  "product": {
    "DIESEL": "محروقات",
    "PETROL": "بنزين",
    "switchLabel": "المنتج",
    "confirmSwitchTitle": "التبديل إلى بنزين؟",
    "confirmSwitchDescription": "ستنتقل شاشة العمليات إلى عرض عمليات البنزين بدلا من المحروقات. يمكنك التبديل مرة أخرى في أي وقت.",
    "confirmSwitchConfirm": "تبديل"
  },
  "operations": {
    "revolvingBalance": "الرصيد المدور",
    "purchase": "الشراء",
    "cashSale": "البيع النقدي",
    "debtSale": "بيع الذمم",
    "debtRepayment": "سداد الذمم",
    "payment": "المدفوعات",
    "receipt": "المقبوضات"
  },
  "shortcutHint": "اختصار: {{digit}}",
  "fields": {
    "cashBalance": "الرصيد النقدي",
    "barrelPurchasePrice": "سعر شراء البرميل",
    "jerrycanPurchasePrice": "سعر شراء الجركل",
    "barrelSalePrice": "سعر بيع البرميل",
    "jerrycanSalePrice": "سعر بيع الجركل",
    "lessJerrycans": "إلا جركل",
    "notes": "ملاحظات",
    "debtor": "المدين",
    "debtorPlaceholder": "ابحث باسم المدين...",
    "debtorInvalidPhone": "رقم غير صالح: لن تصل الحركة إلى العملاء ولا إلى واتساب.",
    "debtorSearchEmpty": "لا يوجد مدينون مطابقون",
    "vehicle": "المركبة",
    "vehicleNone": "بدون مركبة",
    "vehiclePlaceholder": "اختر المركبة",
    "amount": "المبلغ",
    "personName": "اسم الشخص",
    "statement": "البيان",
    "quantities": "الكميات"
  },
  "quantityGrid": {
    "barrels": "البراميل",
    "jerrycans": "الجراكل"
  },
  "summary": {
    "title": "ملخص العملية",
    "totalBarrels": "إجمالي البراميل",
    "totalJerrycans": "إجمالي الجراكل",
    "barrelsAmount": "مبلغ البراميل",
    "jerrycansAmount": "مبلغ الجراكل",
    "amount": "المبلغ",
    "finalTotal": "الإجمالي النهائي",
    "currentBalance": "الرصيد الحالي",
    "debtLimit": "سقف الدين",
    "withinLimit": "ضمن سقف الدين المسموح",
    "overLimit": "يتجاوز سقف الدين المسموح",
    "placeholder": "—"
  },
  "drawers": {
    "revolvingBalance": {
      "title": "الرصيد المدور",
      "description": "تسجيل الرصيد النقدي المدور مع كميات الفئات إن وجدت.",
      "save": "حفظ"
    },
    "purchase": {
      "title": "الشراء",
      "description": "تسجيل عملية شراء بأسعار قابلة للتعديل.",
      "save": "حفظ"
    },
    "cashSale": {
      "title": "البيع النقدي",
      "description": "تسجيل عملية بيع نقدي بأسعار قابلة للتعديل.",
      "save": "حفظ"
    },
    "debtSale": {
      "title": "بيع الذمم",
      "description": "تسجيل عملية بيع على حساب أحد عملاء الذمم.",
      "save": "حفظ"
    },
    "debtRepayment": {
      "title": "سداد الذمم",
      "description": "تسجيل سداد على حساب أحد عملاء الذمم.",
      "save": "حفظ"
    },
    "payment": {
      "title": "المدفوعات",
      "description": "تسجيل دفعة نقدية صادرة.",
      "save": "حفظ"
    },
    "receipt": {
      "title": "المقبوضات",
      "description": "تسجيل مبلغ نقدي وارد.",
      "save": "حفظ"
    },
    "cancel": "إلغاء",
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "لم يتم حفظ البيانات المدخلة. سيتم فقدانها إذا تابعت.",
    "discardConfirm": "تجاهل",
    "discardCancel": "متابعة التعديل"
  },
  "confirm": {
    "title": "تأكيد الحفظ",
    "description": "سيتم تسجيل هذه العملية بشكل نهائي تحت الفرع وتاريخ العمل الحالي.",
    "operation": "العملية",
    "product": "المنتج",
    "commit": "حفظ",
    "cancel": "إلغاء"
  },
  "result": {
    "title": "تمت العملية بنجاح",
    "revolvingBalanceSaved": "تم حفظ الرصيد المدور بنجاح",
    "print": "طباعة",
    "close": "إغلاق"
  },
  "shiftClose": {
    "action": "إغلاق شفت المحروقات والبنزين",
    "title": "إغلاق شفت المحروقات والبنزين",
    "description": "يغلق شفت المحروقات والبنزين معا وينتقل إلى تاريخ العمل التالي. لا عمليات على أي منتج قبل إدخال رصيده المدور.",
    "closingDate": "تاريخ العمل المغلق",
    "nextDate": "تاريخ العمل التالي",
    "balanceEntered": "تم إدخال الرصيد المدور",
    "balanceMissing": "لم يدخل الرصيد المدور",
    "password": "كلمة مرور الإغلاق",
    "confirm": "تأكيد",
    "cancel": "إلغاء",
    "success": "تم إغلاق شفت المحروقات والبنزين. تاريخ العمل الجديد {{date}}"
  },
  "validation": {
    "required": "هذا الحقل مطلوب",
    "positive": "يجب أن تكون القيمة أكبر من صفر",
    "nonNegative": "يجب ألا تكون القيمة سالبة",
    "atLeastOneQuantity": "أدخل كمية برميل أو جركل واحدة على الأقل",
    "invalidNumber": "القيمة يجب أن تكون رقما صحيحا",
    "tooManyDecimals": "يسمح بخمس منازل عشرية كحد أقصى."
  },
  "archive": {
    "title": "أرشيف — للقراءة فقط",
    "description": "تطبيق العمليات غير متاح في بيئة الأرشيف. لا يمكن إدخال أي حركة هنا.",
    "backToSystems": "الأنظمة"
  },
  "shiftStatus": {
    "title": "حالة الشفت",
    "active": "نشط",
    "closed": "مغلق",
    "closedAt": "تاريخ ووقت الإغلاق"
  },
  "inventoryMode": {
    "notice": "وضع الجرد مفعل: تحفظ المشتريات والمبيعات والمدفوعات والمقبوضات معلقة حتى ترحيلها"
  },
  "lookup": {
    "title": "بحث عن حركة",
    "field": "رقم الحركة",
    "placeholder": "امسح الرمز أو اكتب رقم الحركة",
    "search": "بحث",
    "scan": "مسح الرمز",
    "scanTitle": "مسح الرمز",
    "scanHint": "وجه الكاميرا إلى رمز QR في الوصل",
    "typeInstead": "إدخال الرقم يدويا",
    "camera": {
      "denied": "لا يمكن استخدام الكاميرا. اسمح بالوصول إلى الكاميرا من إعدادات المتصفح أو أدخل الرقم يدويا",
      "unavailable": "المسح بالكاميرا غير متاح في هذا المتصفح، أدخل الرقم يدويا"
    },
    "detailsTitle": "تفاصيل الحركة",
    "reference": "رقم الحركة",
    "type": "نوع الحركة",
    "product": "المادة",
    "dateTime": "التاريخ والوقت",
    "employee": "الموظف",
    "pdaEmployee": "موظف PDA",
    "customer": "العميل",
    "phone": "رقم الهاتف",
    "barrelPrice": "سعر البرميل",
    "jerrycanPrice": "سعر الجركل",
    "pricedAt": "وقت الإكمال",
    "deliveredAt": "وقت التسليم",
    "category": "الفئة",
    "quantity": "الكمية",
    "close": "إغلاق",
    "confirmDelivery": "تأكيد التسليم",
    "deliverTitle": "تأكيد تسليم الحركة {{reference}}؟",
    "deliverDescription": "سيتم تسجيل الحركة كمسلمة باسمك. لا يمكن التراجع عن التسليم.",
    "deliverySaved": "تم تسجيل التسليم",
    "kind": {
      "PURCHASE": "شراء",
      "PDA_PURCHASE": "شراء PDA",
      "CASH_SALE": "بيع نقدي",
      "DEBT_SALE": "بيع ذمم",
      "DEBT_REPAYMENT": "سداد ذمم",
      "PAYMENT": "مدفوعات",
      "RECEIPT": "مقبوضات",
      "REVOLVING_BALANCE": "رصيد مدور",
      "PDA_SALE": "بيع PDA"
    },
    "status": {
      "PENDING_PRICE": "بانتظار الإكمال",
      "PRICED": "مكتملة",
      "PENDING_DELIVERY": "بانتظار التسليم",
      "DELIVERED": "تم التسليم",
      "RECORDED": "مسجلة",
      "CANCELLED": "ملغاة"
    },
    "block": {
      "WRONG_PRODUCT": "هذه حركة {{product}}، انتقل إلى مادة {{product}} للمتابعة",
      "CANCELLED": "الحركة ملغاة",
      "ALREADY_PRICED": "تم إكمال الحركة مسبقا",
      "ALREADY_DELIVERED": "تم التسليم مسبقا",
      "NO_ACTION": "لا يوجد إجراء متاح لهذه الحركة",
      "NOT_PERMITTED": "لا تملك صلاحية متابعة هذه الحركة، راجع مدير النظام"
    },
    "postingStatus": "حالة الترحيل",
    "posting": {
      "POSTED": "مرحلة",
      "PENDING": "غير مرحلة"
    },
    "continue": "متابعة الحركة",
    "completeTitle": "إكمال الحركة",
    "completeDescription": "البيانات المسجلة على الـ PDA معبأة مسبقا. أدخل سعري الشراء أو أكدهما ثم أكمل الحركة.",
    "completeSubmit": "إكمال الحركة",
    "completeInvalid": "أدخل سعري البرميل والجركل بقيم أكبر من صفر",
    "completeConfirmDescription": "ستكمل الحركة بهذه الأسعار باسمك. لا تتغير الكميات ولا تاريخ العمل، ولا يمكن إكمالها مرة أخرى.",
    "quantitiesLocked": "الكميات كما سجلها موظف PDA ولا يمكن تعديلها هنا.",
    "completed": "تم إكمال الحركة",
    "completeSaleDescription": "البيانات المسجلة على الـ PDA معبأة مسبقا. أدخل سعري البيع أو أكدهما ثم أكمل الحركة.",
    "completeSaleConfirmDescription": "ستكمل الحركة بهذه الأسعار باسمك ثم تنتظر التسليم. لا تتغير الكميات ولا تاريخ العمل، ولا يمكن إكمالها مرة أخرى."
  }
}
